import { i18n } from '@bizfly/shared';

import en from '../lang/en.json';
import vi from '../lang/vi.json';

i18n.mergeLocaleMessage('vi', vi);
i18n.mergeLocaleMessage('en', en);

export default i18n;
